import { render, staticRenderFns } from "./IndexDetay.vue?vue&type=template&id=f123a410"
import script from "./IndexDetay.vue?vue&type=script&lang=js"
export * from "./IndexDetay.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports